// This list isn't exhaustive and doesn't control the entire feature across the stack - these config
// entries toggle ONLY FRONTEND BEHAVIORS - see backend code for toggling backend behaviors
//
// Please keep each list of feature keys in alpha order

export const eventTypeConfig: {
  [key: string]: {
    artistAvailability: boolean;
    artistFacingPageUrl: boolean;
    artistOffers: boolean;
    artistSelfBooking: boolean;
    autoInvite: boolean;
    bookingFee: boolean;
    cachedSlugPublicPageUrl: boolean;
    eventCreationSelectCampaign: boolean;
    guestsProgressBarViewable: boolean;
    isGloballyPromotedUsed: boolean;
    onSaleAtEditable: boolean;
    revenueViewable: boolean;
    ticketPriceViewable: boolean;
    todaysEventsPage: boolean;
    venueOffers: boolean;
    visaPresale: boolean;
  };
} = {
  DiscoveryEvent: {
    artistAvailability: true,
    artistFacingPageUrl: false,
    artistOffers: true,
    artistSelfBooking: true,
    autoInvite: true,
    bookingFee: true,
    cachedSlugPublicPageUrl: false,
    eventCreationSelectCampaign: false,
    guestsProgressBarViewable: true,
    isGloballyPromotedUsed: true,
    onSaleAtEditable: false,
    revenueViewable: true,
    ticketPriceViewable: true,
    todaysEventsPage: true,
    venueOffers: true,
    visaPresale: true,
  },
  CommercialPartnershipEvent: {
    artistAvailability: false,
    artistFacingPageUrl: false,
    artistOffers: false,
    artistSelfBooking: false,
    autoInvite: false,
    bookingFee: false,
    cachedSlugPublicPageUrl: false,
    eventCreationSelectCampaign: true,
    guestsProgressBarViewable: false,
    isGloballyPromotedUsed: false,
    onSaleAtEditable: false,
    revenueViewable: false,
    ticketPriceViewable: false,
    todaysEventsPage: false,
    venueOffers: false,
    visaPresale: false,
  },
  PrivateDiscoveryEvent: {
    artistAvailability: false,
    artistFacingPageUrl: false,
    artistOffers: false,
    artistSelfBooking: false,
    autoInvite: false,
    bookingFee: false,
    cachedSlugPublicPageUrl: false,
    eventCreationSelectCampaign: true,
    guestsProgressBarViewable: false,
    isGloballyPromotedUsed: false,
    onSaleAtEditable: false,
    revenueViewable: false,
    ticketPriceViewable: false,
    todaysEventsPage: false,
    venueOffers: false,
    visaPresale: false,
  },
  FeaturedSetEvent: {
    artistAvailability: false,
    artistFacingPageUrl: true,
    artistOffers: false,
    artistSelfBooking: false,
    autoInvite: false,
    bookingFee: false,
    cachedSlugPublicPageUrl: true,
    eventCreationSelectCampaign: false,
    guestsProgressBarViewable: true,
    isGloballyPromotedUsed: true,
    onSaleAtEditable: true,
    revenueViewable: true,
    ticketPriceViewable: true,
    todaysEventsPage: false,
    venueOffers: false,
    visaPresale: false,
  },
};
